import { render, staticRenderFns } from "./AdvProductGallery.vue?vue&type=template&id=845811c6&scoped=true"
import script from "./AdvProductGallery.vue?vue&type=script&lang=js"
export * from "./AdvProductGallery.vue?vue&type=script&lang=js"
import style0 from "./AdvProductGallery.vue?vue&type=style&index=0&id=845811c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845811c6",
  null
  
)

export default component.exports